export const PREFIX = 'hero-theme'
export const DOT_PREFIX = `.${PREFIX}`
